import { MapPin, Phone, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0A0C] pt-16 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <p
          aria-hidden="true"
          className="font-display uppercase text-[18vw] lg:text-[11rem] leading-[0.8] text-stroke-cream select-none whitespace-nowrap"
        >
          Lateresina
        </p>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mt-12">
          <div className="space-y-3 text-sm text-stone-400">
            <p className="flex items-center gap-2">
              <MapPin size={15} className="text-[#D34E36]" />
              Piazza XX Settembre 22/23, 14049 Nizza Monferrato (AT)
            </p>
            <p className="flex items-center gap-2">
              <Phone size={15} className="text-[#D34E36]" />
              <a href="tel:+393937347177" data-testid="footer-phone-link" className="hover:text-[#F49D37] transition-colors">
                +39 393 7347177
              </a>
            </p>
            <p className="text-xs text-stone-500">Aperto 19:00 – 02:00 · Chiuso il martedì · Coperto € 1,50</p>
            <a
              href="https://www.instagram.com/lateresina_nizza_monferrato"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-2 text-[11px] font-mono2 uppercase tracking-[0.2em] text-stone-400 hover:text-[#F49D37] transition-colors pt-1"
            >
              <Instagram size={14} /> @lateresina_nizza_monferrato
            </a>
          </div>
          <nav className="flex flex-wrap gap-5 text-[11px] font-mono2 uppercase tracking-[0.2em] text-stone-500">
            <a href="#chi-siamo" data-testid="footer-link-chi-siamo" className="hover:text-[#F49D37] transition-colors">Chi Siamo</a>
            <a href="#menu" data-testid="footer-link-menu" className="hover:text-[#F49D37] transition-colors">Menù</a>
            <a href="#galleria" data-testid="footer-link-galleria" className="hover:text-[#F49D37] transition-colors">Galleria</a>
            <a href="#contatti" data-testid="footer-link-contatti" className="hover:text-[#F49D37] transition-colors">Contatti</a>
            <a href="/gestione" data-testid="footer-admin-link" className="hover:text-[#F49D37] transition-colors">Gestione</a>
          </nav>
        </div>

        <p className="text-xs text-stone-600 mt-12 pt-6 border-t border-white/5">
          © {new Date().getFullYear()} Lateresina — Nizza Monferrato. Tutti i diritti riservati.
        </p>
      </div>
    </footer>
  );
}
